/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2019, 2021
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'../../../../widgets/livewidget/nls/StringResources',
	'../../../../lib/@waca/dashboard-common/dist/core/APIFactory',
	'../api/SlotActionsProviderAPI'
], function(stringResources, APIFactory, SlotActionsProviderAPI) {

	return class DeleteAction {

		constructor({ dashboardAPI, content, features }) {
			this.dashboard = dashboardAPI;
			this.content = content;
			this.features = features;
			features.SlotActions.registerProvider('deleteAction', this.getAPI());
		}

		getSlotActionList(dataSlotId, itemIndex, options) {
			const dataSlot = this.content.getFeature('Visualization').getSlots().getSlot(dataSlotId);
			const deleteIcon = this.features['Dashboard.Icons'].getIcon('TrashIcon');
			if(dataSlot && this._supportAction(dataSlot, itemIndex, options)) {
				return [{
					name: 'delete',
					label: stringResources.get('toolbarDeleteActionText'),
					icon: deleteIcon.id,
					type: 'Button',
					group: 'deleteAction',
					removeThenApplyAction: true,
					actions: {
						apply: this.deleteSlot.bind(this, dataSlot, itemIndex)
					}
				}];
			}
			return [];
		}

		_supportAction(dataSlot, itemIndex, options) {
			if(this.dashboard.getMode() !== this.dashboard.MODES.EDIT) {
				return false;
			}

			// Do not support action if excludeAction is true. Currently used by crosstab.
			if(options && options.excludeAction) {
				return false;
			}

			// We do not support delete action when clicking on the legend or on viz labels.
			if(itemIndex === null || itemIndex === undefined) {
				return false;
			}

			let dataItem = dataSlot.getDataItemList()[itemIndex];
			if(dataItem && dataItem.getColumnId() === '_multiMeasuresSeries') {
				return false;
			}

			// We do not support delete action in multiple selections.
			// (eg. selecting multiple columns in crosstab)
			if(Array.isArray(itemIndex)) {
				return false;
			}

			return true;
		}

		deleteSlot(dataSlot, itemIndex) {
			let dataItem = dataSlot.getDataItemList()[itemIndex];
			const ids = [dataItem.getId()];
			dataSlot.removeDataItems(ids);
		}

		getAPI() {
			if (!this._api) {
				this._api = APIFactory.createAPI(this, [SlotActionsProviderAPI]);
			}
			return this._api;
		}
	};
});
